import { DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { UnsavedChangesTrackerService } from './unsaved-changes-tracker.service';

/** Bind a reactive form's dirty state to a named unsaved-changes source. */
export function bindFormDirtyTracking(
  form: AbstractControl,
  sourceId: string,
  tracker: UnsavedChangesTrackerService,
  destroyRef: DestroyRef
): void {
  form.valueChanges.pipe(takeUntilDestroyed(destroyRef)).subscribe(() => {
    tracker.setDirty(sourceId, form.dirty);
  });
}

/** Mark the form pristine and clear its dirty source (after load / successful save). */
export function clearFormUnsavedChanges(
  form: AbstractControl,
  sourceId: string,
  tracker: UnsavedChangesTrackerService
): void {
  form.markAsPristine();
  tracker.clear(sourceId);
}
